import React from "react";
import {
  BrowserRouter as Router, Route, Switch, useRouteMatch
} from "react-router-dom";

import './ladder.css';
import BasicTabs from "./tabs";

export default function ANULadder() {
  let match = useRouteMatch();

  return (
    <div id="ladder-container"
      className="center">
      <h1>Competition Leaderboard</h1>
      <Router>

        <BasicTabs match={match}></BasicTabs>
      </Router>
    </div>
  )
}
